import { createExecCommandCallback } from "../../elfinder/ElFinder.ts";

export function showAdvancedEditModeHelpDialog(fm: elFinder.ElFinderInstance): void {
  const header = fm.i18n("fcHelpDialogHeader");
  const content = fm.i18n("fcHelpDialogContent");
  const dialog = fm.dialog(`<div style="margin: 10px">${content}</div>`, {
    title: header,
    width: 600,
    modal: true,
    resizable: false,
    close: () => dialog.elfinderdialog("destroy"),
    buttons: {
      [fm.i18n("btnClose")]: () => dialog.elfinderdialog("close"),
    },
  });
}

async function showFcHelp(fm: elFinder.ElFinderInstance): Promise<void> {
  showAdvancedEditModeHelpDialog(fm);
}

/**
 * Creates an ElFinder command that opens the help dialog for the advanced edit mode.
 * @returns The new ElFinder command.
 */
export function createShowFcHelpCommand(): elFinder.ElFinderCommandHandlerBaseStatic<elFinder.BaseElFinderCommandOptions> {
  const command: elFinder.ElFinderCommandHandlerBaseStatic<elFinder.BaseElFinderCommandOptions> = function () {
    this.getstate = () => 0;
    this.exec = createExecCommandCallback(showFcHelp);

    this.init = function (this: elFinder.ElFinderCommandHandlerBase<elFinder.BaseElFinderCommandOptions>) {
      this.className = "show-fc-help";
      this.title = this.fm.i18n("showFcHelp");
      this.name = "showFcHelp";
    };
  };

  return command;
}
